import { ABOUT_SLUG } from "../core/urls";
import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import DashHeading from "./DashHeading";
import IndentedParagraphMedium from "./IndentedParagraphMedium";
import MediumLink from "./MediumLink";
import React from "react";

function WhatHappens({ heading, text, learnMore }) {
  const aboutHref = `/${ABOUT_SLUG}`;
  return (
    <Box
      bg="mushroom"
      pt={[50, null, "6.66vw", null]}
      pb={[80, null, 120, null]}
    >
      <BoxWithGutter>
        <DashHeading heading={heading} />
        <Box
          maxWidth={[null, "80vw", null, null]}
          mx="auto"
          mt={[40, null, 60, null]}
        >
          <IndentedParagraphMedium>{text}</IndentedParagraphMedium>
        </Box>
        {learnMore && (
          <Box mt={[40, null, 60, null]}>
            <MediumLink
              text="Learn more"
              href={aboutHref}
              ariaLabel="Learn more about Reskinned"
            />
          </Box>
        )}
      </BoxWithGutter>
    </Box>
  );
}

export default WhatHappens;
